import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=50f185d8"
import script from "./UserFilter.vue?vue&type=script&lang=js"
export * from "./UserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports